import { GET_PROPERTY_MESSAGE_TEMPLATES_VARIABLES } from "@/store/property-message-templates/actions";
export default {
  props: {
    variableFilters: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  methods: {
    async initVariables(editor) {
      const placeholders = await this.loadVariables();
      placeholders.forEach((placeholder) => {
        const componentName = placeholder.text;
        editor.DomComponents.addType(componentName, {
          model: {
            defaults: {
              tagName: "span",
              attributes: { class: "placeholder-text" },
              components: [
                {
                  type: "text",
                  content: placeholder.value
                }
              ],
              droppable: false,
              editable: true
            }
          }
        });

        editor.BlockManager.add(componentName, {
          label: componentName,
          category: "Placeholders",
          content: { type: componentName },
          attributes: { class: "mdi mdi-tag" }
        });
      });
    },
    async loadVariables() {
      return await this.$store.dispatch(GET_PROPERTY_MESSAGE_TEMPLATES_VARIABLES, this.variableFilters);
    }
  }
};
